import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/js/bootstrap.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

import { SteamApiApp } from "./SteamApiApp";

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<SteamApiApp />
	</React.StrictMode>
);
